import React, { useState } from "react";
import { ArrowUpRight } from "lucide-react";

export default function FlipCard({ item, index }) {
  const [flipped, setFlipped] = useState(false);
  return (
    <div
      data-testid={`flip-card-${item.id}`}
      className={`flip-card ${flipped ? "is-flipped" : ""} min-h-[440px] cursor-pointer`}
      onClick={() => setFlipped((v) => !v)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") setFlipped((v) => !v);
      }}
      tabIndex={0}
      role="button"
      aria-label={`Reveal case ${item.id}`}
    >
      <div className="flip-card-inner">
        {/* FRONT */}
        <div className="flip-face bg-kingdom text-paper border border-white/5 p-8 md:p-10 flex flex-col justify-between">
          <div>
            <span className="eyebrow">Case 0{index + 1}</span>
            <h3 className="font-display text-2xl md:text-[26px] leading-tight mt-6">
              {item.title}
            </h3>
          </div>
          <div className="mt-10">
            <p className="text-sm text-warm/80 leading-relaxed">{item.front}</p>
            <div className="flex items-center justify-between pt-6 mt-6 border-t border-white/10">
              <span className="text-xs text-gold uppercase tracking-[0.24em]">
                {item.product}
              </span>
              <ArrowUpRight size={18} className="text-gold" />
            </div>
          </div>
        </div>

        {/* BACK */}
        <div className="flip-face flip-back bg-obsidian text-paper border border-gold/20 p-8 md:p-10 flex flex-col justify-center">
          <div>
            <span className="eyebrow">Problem</span>
            <p className="text-[15px] text-warm/85 leading-relaxed mt-3">
              {item.problem}
            </p>
          </div>
          <div className="my-6 gold-hairline"></div>
          <div>
            <span className="eyebrow">HuddleUp Role</span>
            <p className="text-[15px] text-warm/85 leading-relaxed mt-3">
              {item.role}
            </p>
          </div>
          <div className="my-6 gold-hairline"></div>
          <div>
            <span className="eyebrow">Outcome</span>
            <p className="text-[15px] text-warm/85 leading-relaxed mt-3">
              {item.outcome}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
